import { InformationCircleIcon } from '@heroicons/react/20/solid';
import { FC } from 'react';

interface VDPChargingCardWrapperProps {
  title: React.ReactNode;
  value?: string;
  subtitle: string;
  content: React.ReactNode;
  infoCircle?: boolean;
  icon?: React.ReactNode;
}

export const VDPChargingCardWrapper: FC<VDPChargingCardWrapperProps> = ({
  title,
  value,
  subtitle,
  content,
  infoCircle = false,
  icon,
}) => {
  return (
    <div className="relative flex flex-1 flex-col justify-between gap-xs rounded-small border border-neutral-200 bg-neutral-100 px-m py-s">
      {icon}
      <div className="flex flex-grow flex-col">
        <div className="flex flex-col gap-xs">
          <div className="text-microMedium text-neutral-800">{title}</div>
          {value && (
            <div className="text-body1Medium text-neutral-800">{value}</div>
          )}
        </div>
        <div className="text-microLight text-neutral-800">{subtitle}</div>
      </div>
      <div className="flex flex-grow flex-col justify-end">{content}</div>
      {infoCircle && (
        <div className="absolute right-m top-s">
          <InformationCircleIcon className="size-[20px] fill-neutral-600" />
        </div>
      )}
    </div>
  );
};
